"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicePermissionEnum = exports.OffDayPermissionEnum = exports.TranslationPermissionEnum = exports.UserGroupPermissionEnum = exports.UserPermissionEnum = void 0;
var UserPermissionEnum;
(function (UserPermissionEnum) {
    UserPermissionEnum["USER_READ"] = "USER_READ";
    UserPermissionEnum["USER_WRITE"] = "USER_WRITE";
})(UserPermissionEnum = exports.UserPermissionEnum || (exports.UserPermissionEnum = {}));
var UserGroupPermissionEnum;
(function (UserGroupPermissionEnum) {
    UserGroupPermissionEnum["USER_GROUP_READ"] = "USER_GROUP_READ";
    UserGroupPermissionEnum["USER_GROUP_WRITE"] = "USER_GROUP_WRITE";
})(UserGroupPermissionEnum = exports.UserGroupPermissionEnum || (exports.UserGroupPermissionEnum = {}));
var TranslationPermissionEnum;
(function (TranslationPermissionEnum) {
    TranslationPermissionEnum["TRANSLATION_READ"] = "TRANSLATION_READ";
    TranslationPermissionEnum["TRANSLATION_WRITE"] = "TRANSLATION_WRITE";
})(TranslationPermissionEnum = exports.TranslationPermissionEnum || (exports.TranslationPermissionEnum = {}));
var OffDayPermissionEnum;
(function (OffDayPermissionEnum) {
    OffDayPermissionEnum["OFFDAY_READ"] = "OFFDAY_READ";
    OffDayPermissionEnum["OFFDAY_WRITE"] = "OFFDAY_WRITE";
})(OffDayPermissionEnum = exports.OffDayPermissionEnum || (exports.OffDayPermissionEnum = {}));
var ServicePermissionEnum;
(function (ServicePermissionEnum) {
    ServicePermissionEnum["SERVICE_READ"] = "SERVICE_READ";
    ServicePermissionEnum["SERVICE_WRITE"] = "SERVICE_WRITE";
})(ServicePermissionEnum = exports.ServicePermissionEnum || (exports.ServicePermissionEnum = {}));
